import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CertificateService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.baseUrl}/certificate`,{params:searchParams});
    }

    get(deviceId){
      return this.http.get(`${environment.baseUrl}/certificate/`+deviceId);
    }

    edit(deviceId,formData){
      return this.http.put(`${environment.baseUrl}/certificate/`+deviceId,formData);
    }

    create(formData){
      return this.http.post(`${environment.baseUrl}/certificate`,formData);
    }

    delete(deviceId){
      return this.http.delete(`${environment.baseUrl}/certificate/`+deviceId);
    }

}
